<template>
  <section id="dashboard-analytics">
    <b-row class="match-height">
      <b-col class="content-header-left mb-1" cols="12" md="12">
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h2 class="content-header-title float-left pr-1 mb-0">HR</h2>
            <div class="breadcrumb-wrapper">
              <b-breadcrumb style="font-size: 0.9rem">
                <b-breadcrumb-item to="/">
                  <feather-icon
                    icon="HomeIcon"
                    size="14"
                    class="align-text-top"
                  />
                </b-breadcrumb-item>
                <b-breadcrumb-item active> HR </b-breadcrumb-item>
              </b-breadcrumb>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <div
        class="col-xl-2 col-md-3 col-sm-6"
        v-for="data in modules"
        :key="data.route"
      >
        <b-col>
          <statistic-card-vertical
            :icon="data.icon"
            :statistic="data.title"
            color="info"
            :route="data.route"
            :small="data.title == 'Employee Performance' ? true : false"
          />
        </b-col>
      </div>
    </b-row>
    <b-row class="match-height mt-2" v-if="hasHrAccess">
      <b-col cols="12" lg="12">
        <vehicle-expiry-reminders />
      </b-col>
    </b-row>
    <b-row class="match-height mt-2" v-if="hasHrAccess">
      <b-col cols="12" lg="12">
        <birthday-anniversary-widget />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BRow, BCol,
  BBreadcrumb,
  BBreadcrumbItem,} from "bootstrap-vue";
import StatisticCardVertical from "@core/components/statistics-cards/StatisticCardVertical.vue";
import VehicleExpiryReminders from "./VehicleExpiryReminders.vue";
import BirthdayAnniversaryWidget from "./BirthdayAnniversaryWidget.vue";
import axios from "@/components/axios";

export default {
  components: {
    StatisticCardVertical,
    BRow,
    BCol,
    BBreadcrumb,
    BBreadcrumbItem,
    VehicleExpiryReminders,
    BirthdayAnniversaryWidget,
    // InvoiceList,
  },
  data() {
    return {
      data: [
        {
          icon: "UserIcon",
          title: "Daily Working",
          route: "/hr/dailyworking",
        },
        {
          icon: "FileTextIcon",
          title: "Document",
          route: "/hr/document",
        },
        {
          icon: "PhoneIcon",
          title: "Salary",
          route: "/hr/salary",
        },
        {
          icon: "EditIcon",
          title: "Memo",
          route: "/hr/memo",
        },
        {
          icon: "UserPlusIcon",
          title: "Job Vacancy",
          route: "/hr/jobvacancy",
        },
        {
          icon: "UserIcon",
          title: "Employee",
          route: "/hr/employee",
        },
        {
          icon: "StarIcon",
          title: "Attendance",
          route: "/hr/attendance",
        },
        {
          icon: "SlackIcon",
          title: "Tree",
          route: "/crm/tree",
        },
        {
          icon: "StarIcon",
          title: "Leaves",
          route: "/hr/leaves",
        },
        {
          icon: "CalendarIcon",
          title: "Holiday",
          route: "/master/hr/holiday",
        },
        {
          icon: "FileMinusIcon",
          title: "Resume",
          route: "/hr/resume",
        },
        {
          icon: "StarIcon",
          title: "Employee Performance Management",
          route: "/hr/employeeperformancemanagement",
        },
        {
          icon: "StarIcon",
          title: "Asset Tracker",
          route: "/hr/assettracker",
        },
        {
          icon: "StarIcon",
          title: "Register",
          route: "/hr/register",
        },
         {
          icon: "StarIcon",
          title: "Request",
          route: "/hr/hrrequest",
        },
      ],
      userData: localStorage.getItem("userData"),
      userRole: "",
      userType: "",
      modules: [],
      sidebarData: "",
      assignRights: {},
      baseApi: process.env.VUE_APP_APIENDPOINT,
    };
  },
  computed: {
    hasHrAccess() {
      // Check if user type is admin or contains "hr" (for hr head, hr assistant, etc.)
      // Also check role as fallback for backward compatibility
      const typeLower = (this.userType || "").toLowerCase();
      const roleLower = (this.userRole || "").toLowerCase();
      return typeLower === "admin" || typeLower.includes("hr") || roleLower === "admin" || roleLower === "hr";
    },
  },
  created() {
    // data
    // this.$http.get('/analytics/data').then((response) => {
    //   this.data = response.data
    // })
  },
  async mounted() {
    const parsedUserData = JSON.parse(this.userData);
    this.userRole = parsedUserData.role;
    this.userType = parsedUserData.type;
    this.sidebarData = JSON.parse(localStorage.getItem("sidebarData"));
    
    // Fetch assign rights to check for Holiday module assigned via assign-rights page
    // The route is /api/v1/hr/getAssignRights (inside v1/hr route group)
    try {
      const response = await axios.get(`${this.baseApi}/v1/hr/getAssignRights`);
      if (response && response.data && response.data.status && response.data.rights) {
        this.assignRights = response.data.rights;
        console.log('Assign Rights loaded:', this.assignRights);
      }
    } catch (error) {
      console.warn('Could not fetch assign rights:', error);
      this.assignRights = {};
    }
    
    this.setRoute();
  },
  methods: {
    // kFormatter
    setRoute() {
      // Initialize modules array
      this.modules = [];
      
      // Get modules from sidebarData (HR section)
      if (this.sidebarData && Array.isArray(this.sidebarData)) {
        this.sidebarData.map((item) => {
          if (item.title == "HR" || item.title == "hr") {
            this.modules = item.children || [];
          }
        });
      }
      
      // Ensure modules is an array
      if (!Array.isArray(this.modules)) {
        this.modules = [];
      }
      
      // Check assignRights for Holiday module and add it if user has view rights
      // This handles cases where Holiday is in Master section but should appear on HR dashboard
      // Check with case-insensitive matching
      if (this.assignRights && Object.keys(this.assignRights).length > 0) {
        const holidayKey = Object.keys(this.assignRights).find(
          key => key && key.toLowerCase() === 'holiday'
        );
        
        if (holidayKey && this.assignRights[holidayKey]) {
          const holidayRights = this.assignRights[holidayKey];
          const hasViewRights = holidayRights.canView === true || 
                               holidayRights.canView === 1 || 
                               holidayRights.canView === '1' ||
                               holidayRights.view === true ||
                               holidayRights.view === 1 ||
                               holidayRights.view === '1';
          
          if (hasViewRights) {
            // Check if Holiday is already in modules (case-insensitive)
            const holidayExists = this.modules.some(m => 
              m && m.title && m.title.toLowerCase() === 'holiday'
            );
            if (!holidayExists) {
              // Add Holiday module from hardcoded data
              const holidayData = this.data.find(d => d.title === 'Holiday');
              if (holidayData) {
                this.modules.push({
                  title: 'Holiday',
                  route: holidayData.route,
                  icon: holidayData.icon,
                });
                console.log('Holiday module added to HR dashboard from assign_rights');
              } else {
                console.warn('Holiday data not found in hardcoded data array');
              }
            }
          }
        }
      }
      
      // Map routes from hardcoded data array
      this.modules = this.modules.map((item) => {
        if (!item) return item;
        
        this.data.map((inner) => {
          if (inner.title == item.title) {
            if(inner.title == 'Employee Performance Management'){
              item.title='Employee Performance'
            }
            item.route = inner.route;
            item.icon = inner.icon || item.icon; // Use icon from data array if available
          }
        });
        return item;
      });
      
      console.log('Final HR Dashboard Modules:', this.modules);
    },
  },
};
</script>